/**
 * SETTINGS_REDIRECT_ROUTES — the retired-URL redirect table as REAL route
 * elements, consumed by BOTH App.tsx and the redirect test (single source:
 * the test exercises the exact elements the app renders).
 *
 * Only legacy redirects live here — the new settings subtree stays in App.
 */

import { Navigate, Route } from 'react-router-dom';
import { LegacyWorkspaceSettingsRedirect } from './LegacyWorkspaceSettingsRedirect';

export const SETTINGS_REDIRECT_ROUTES = [
  <Route
    key="workspace-settings"
    path="workspace-settings"
    element={<LegacyWorkspaceSettingsRedirect />}
  />,
  <Route key="tenant-settings" path="tenant-settings" element={<Navigate to="/settings" replace />} />,
  <Route key="account" path="account" element={<Navigate to="/settings/team" replace />} />,
  <Route key="assets" path="assets" element={<Navigate to="/settings/media" replace />} />,
  <Route
    key="seo-content-preferences"
    path="seo/content-preferences"
    element={
      <Navigate
        to="/settings/content"
        replace
      />
    }
  />,
];
